import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type UserIdStore = {
    userId: string | null;
    setUserId: (userId: string) => void;
    clearUserId: () => void;
    getUserId: () => string | null;
    syncWithCookie: () => void;
    initializeFromStorage: () => void;
};

const getCookieValue = (name: string): string | null => {
    try {
        const value = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${name}=`))
            ?.split('=')[1];
        return value || null;
    } catch (error) {
        return null;
    }
};

const setCookieValue = (name: string, value: string, maxAge: number = 31536000) => {
    try {
        document.cookie = `${name}=${value}; max-age=${maxAge}; path=/`;
    } catch (error) {
        console.warn(`Erro ao definir cookie ${name}:`, error);
    }
};

const useUserIdStore = create<UserIdStore>()(
    persist(
        (set, get) => ({
            userId: null,

            setUserId: (userId: string) => {
                set({ userId });
                setCookieValue('uticket_userid', userId);
            },

            clearUserId: () => {
                set({ userId: null });
                setCookieValue('uticket_userid', '', 0);
            },

            getUserId: () => {
                const { userId } = get();

                if (userId) {
                    setCookieValue('uticket_userid', userId);
                    return userId;
                }

                const cookieValue = getCookieValue('uticket_userid');
                if (cookieValue) {
                    set({ userId: cookieValue });
                    return cookieValue;
                }

                return null;
            },

            syncWithCookie: () => {
                const { userId } = get();
                if (userId) {
                    setCookieValue('uticket_userid', userId);
                } else {
                    const cookieValue = getCookieValue('uticket_userid');
                    if (cookieValue) {
                        set({ userId: cookieValue });
                    }
                }
            },

            initializeFromStorage: () => {
                const { userId } = get();

                if (!userId) {
                    const cookieValue = getCookieValue('uticket_userid');
                    if (cookieValue) {
                        set({ userId: cookieValue });
                    }
                } else {
                    setCookieValue('uticket_userid', userId);
                }
            }
        }),
        {
            name: 'uticket:userid',
            partialize: (state) => ({ userId: state.userId }),
            onRehydrateStorage: () => (state) => {
                if (state) {
                    state.initializeFromStorage();
                }
            }
        }
    )
);

if (typeof window !== 'undefined') {
    setTimeout(() => {
        useUserIdStore.getState().initializeFromStorage();
    }, 0);
}

export default useUserIdStore;
